<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div class="broker-board">
    <div>
        <button mdbBtn (click)="createBroker()"
        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height">Create Broker</button>
    </div>
</div>
<div>
    <app-grid *ngIf="brokerList.length > 0" [type]="gridType" [data]="brokerList" [defaultColumns]="headers" 
        [matchedHeaders]="matchedHeaders" (loadBrokerList)="reLoadBrokerList($event)">
    </app-grid>
</div>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
aria-labelledby="myBasicModalLabel" aria-hidden="true"
[config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
<div class="modal-dialog modal-md modal-dialog-centered" role="document">

  <div class="modal-content">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
      <span aria-hidden="true" class="">&times;</span>
    </button>
    <div class="row text-left">

      <!--Grid column-->
      <div class="col-md-12 rmSectionPopup">
        <div class="row p-2 m-2">

          <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
            <p class="mt-2 p-0">{{responseMessage}} </p>

            <div class="action-buttons">
              <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                mdbWavesEffect type="submit" (click)="successModal.hide()">ok
              </button>



            </div>

          </div>
        </div>

      </div>

      <!--Grid column-->



    </div>
  </div>
</div>
</div>